<template>
  <div id="app" :class="{ 'device-mobile': isMobileDevice, 'device-pc': !isMobileDevice }">
    <!-- 用户信息编辑对话框 -->
    <UserProfileDialog
      :visible.sync="profileDialogVisible"
      :user-info="currentUserInfo"
      @profile-updated="handleProfileUpdated"
    />
    
    <!-- 移动端菜单按钮 -->
    <el-button
      class="mobile-menu-btn"
      circle
      v-show="isMobileDevice"
      @click="toggleMenu"
    >
      <i class="el-icon-menu" style="font-size: 32px;"></i>
    </el-button>

    <!-- 回到顶部按钮 -->
    <el-button
      class="back-to-top-btn"
      circle
      v-show="showBackToTop" 
      @click.stop="scrollToTop"
      title="回到顶部"
    >
      <i class="el-icon-top" style="font-size: 20px;"></i>
    </el-button>

    <!-- 移动端导航抽屉 -->
    <el-drawer
      :visible.sync="showMenu"
      title="导航菜单"
      direction="ltr"
      size="175px"
      :modal="false"
      :wrapperClosable="true"
      :with-header="false"
      custom-class="mobile-drawer"
      :show-close="false"
    >
      <!-- Logo区域 -->
      <div class="drawer-logo">
        <div class="drawer-title">
          <img src="@/assets/images/logo/oier-logo.svg" alt="OIer之路" class="drawer-logo-img">
        </div>
        <el-button icon="el-icon-close" circle size="mini" class="close-btn" @click="showMenu = false"></el-button>
      </div>
      <el-menu
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#eeba4c"
        class="mobile-menu"
        :collapse-transition="false"
      >
        <!-- 首页 -->
        <el-menu-item @click="navigateTo('/welcome')">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        
        <!-- 数据菜单 -->
        <el-submenu index="analysis" class="no-submenu-line">
          <template slot="title">
            <i class="el-icon-data-line"></i>
            <span>数据</span>
          </template>
          <el-menu-item @click="navigateTo('/analysis/panel')">
            <i class="el-icon-data-analysis"></i>
            <span>数据面板</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/analysis/monthly')">
            <i class="el-icon-data-analysis"></i>
            <span>月度环比</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/analysis/wrong-analysis')">
            <i class="el-icon-warning"></i>
            <span>错题分析</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/analysis/correction-analysis')">
            <i class="el-icon-edit"></i>
            <span>订正分析</span>
          </el-menu-item>
        </el-submenu>
        
        <!-- 赛事 -->
        <el-menu-item @click="navigateTo('/game')">
          <i class="el-icon-trophy"></i>
          <span slot="title">赛事</span>
        </el-menu-item>
        
        <!-- 题目 -->
        <el-menu-item @click="navigateTo('/question')">
          <i class="el-icon-document-checked"></i>
          <span slot="title">题目</span>
        </el-menu-item>
        
        <!-- 错题 -->
        <el-menu-item @click="navigateTo('/wrongbook')">
          <i class="el-icon-edit-outline"></i>
          <span slot="title">错题</span>
        </el-menu-item>
        
        <!-- 标签 -->
        <el-menu-item @click="navigateTo('/tag')">
          <i class="el-icon-collection-tag"></i>
          <span slot="title">标签</span>
        </el-menu-item>
        
        <!-- 大纲 -->
        <el-menu-item @click="navigateTo('/outline')">
          <i class="el-icon-notebook-2"></i>
          <span slot="title">大纲</span>
        </el-menu-item>
        
        <!-- 计划 -->
        <el-menu-item @click="navigateTo('/plan')">
          <i class="el-icon-time"></i>
          <span slot="title">计划</span>
        </el-menu-item>
        
        <!-- 文章菜单 -->
        <el-submenu index="article" class="no-submenu-line">
          <template slot="title">
            <i class="el-icon-reading"></i>
            <span>文章</span>
          </template>
          <el-menu-item @click="navigateTo('/article')">
            <i class="el-icon-document"></i>
            <span>管理</span>
          </el-menu-item>
          <el-menu-item @click="openBlogInNewTab">
            <i class="el-icon-notebook-1"></i>
            <span>博客</span>
          </el-menu-item>
        </el-submenu>
        
        <!-- 管理菜单 -->
        <el-submenu index="manage" class="no-submenu-line">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>管理</span>
          </template>
          <el-menu-item @click="navigateTo('/system/friend-link')">
            <i class="el-icon-link"></i>
            <span>友链管理</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/system/dict')">
            <i class="el-icon-collection"></i>
            <span>字典管理</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/system/user')">
            <i class="el-icon-user"></i>
            <span>用户管理</span>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/system/great-event')">
            <i class="el-icon-star-on"></i>
            <span>大事记管理</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
      <!-- 底部用户信息和退出按钮（与PC端一致） -->
      <div class="drawer-bottom-container">
        <div class="bottom-buttons">
          <el-tooltip :content="username || '未登录'" placement="right">
            <div class="avatar" @click="handleEditProfile">{{ getFirstChar }}</div>
          </el-tooltip>
          <el-tooltip content="退出登录" placement="right">
            <div class="logout-btn" @click="handleLogout">
              <i class="el-icon-switch-button"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </el-drawer>
    
    <router-view />
  </div>
</template>

<script>
import { isMobile, addResizeListener } from '@/utils/device'
import UserProfileDialog from '@/components/UserProfileDialog.vue'
import request from '@/utils/request'

export default {
  name: 'App',
  components: {
    UserProfileDialog
  },
  data() {
    return {
      showMenu: false, // 移动端菜单抽屉显示状态
      showBackToTop: false, // 回到顶部按钮显示状态
      isMobileDevice: false,
      removeResizeListener: null,
      username: '',
      profileDialogVisible: false,
      currentUserInfo: {}
    }
  },
  
  computed: {
    getFirstChar() {
      if (!this.username) return '?'
      const name = this.username.trim()
      if (name.length === 0) return '?'
      const hasChinese = /[\u4e00-\u9fa5]/.test(name)
      if (!hasChinese) {
        return name.charAt(0).toUpperCase()
      }
      const chineseChars = name.match(/[\u4e00-\u9fa5]/g)
      if (!chineseChars) return name.charAt(0)
      switch (chineseChars.length) {
        case 1:
          return chineseChars[0]
        case 2:
          return chineseChars[1]
        case 3:
          return chineseChars[1]
        case 4:
          return chineseChars[3]
        default:
          return chineseChars[0]
      }
    }
  },
  methods: {
    handleWrongbookClick() {
      this.$message({ type: 'info', message: '错题本功能开发中，敬请期待～' })
    },
    // 以下方法已存在，避免重复，这里只放新增的方法占位
  },

  watch: {
    // 监听菜单状态变化
    showMenu(newVal) {
      // 当菜单打开时，隐藏回到顶部按钮
      if (newVal) {
        this.showBackToTop = false
      } else {
        // 菜单关闭时，重新检查是否需要显示回到顶部按钮
        this.showBackToTop = window.pageYOffset > 300
      }
    },
    
    // 监听路由变化
    '$route'() {
      // 路由变化时，重新检查是否需要显示回到顶部按钮
      this.showBackToTop = window.pageYOffset > 300 && !this.showMenu
    }
  },
  created() {
    document.title = 'OIer 之路'
    this.loadUserInfo()
  },
  mounted() {
    // 添加滚动监听
    this.addScrollListener()
    
    // 初始化设备类型并监听变化（统一使用 device.js 判断）
    this.isMobileDevice = isMobile()
    this.removeResizeListener = addResizeListener(() => {
      this.isMobileDevice = isMobile()
    })

    // 页面加载时检查滚动位置
    this.$nextTick(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.showBackToTop = scrollTop > 300 && !this.showMenu
      
      // 调试信息
      console.log('回到顶部按钮调试信息:', {
        scrollTop,
        showMenu: this.showMenu,
        showBackToTop: this.showBackToTop
      })
    })
  },
  beforeDestroy() {
    // 移除滚动监听
    this.removeScrollListener()
    // 移除窗口大小变化监听
    if (this.removeResizeListener) {
      this.removeResizeListener()
      this.removeResizeListener = null
    }
  },
  methods: {
    // 加载用户信息
    async loadUserInfo() {
      try {
        const response = await request({
          url: '/api/user/info',
          method: 'get'
        })
        
        if (response.code === 200) {
          this.currentUserInfo = response.data
          this.username = response.data.name || ''
          
          // 更新本地存储
          const userInfo = {
            id: response.data.id,
            username: response.data.username,
            name: response.data.name,
            sex: response.data.sex,
            birthday: response.data.birthday
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
        }
      } catch (error) {
        console.error('加载用户信息失败:', error)
        // 如果API失败，尝试从本地存储获取
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
          const userData = JSON.parse(userInfo)
          this.currentUserInfo = userData
          this.username = userData.name || ''
        }
      }
    },
    
    // 编辑个人信息
    handleEditProfile() {
      this.profileDialogVisible = true
    },
    
    // 处理个人信息更新
    handleProfileUpdated(updatedInfo) {
      this.username = updatedInfo.name
      this.currentUserInfo = {
        ...this.currentUserInfo,
        ...updatedInfo
      }
    },
    
    // 在新标签页中打开博客链接
    openBlogInNewTab() {
      const url = `${window.location.origin}/blog`;
      window.open(url, '_blank');
      this.showMenu = false;
    },

    // 导航方法
    navigateTo(path) {
      this.$router.push(path)
      this.showMenu = false
    },
    
    handleLogout() {
      const options = {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: true,
        closeOnPressEscape: true
      }
      if (this.isMobileDevice) {
        options.customClass = 'mobile-confirm'
        options.center = true
      }
      this.$confirm('确认退出登录吗?', '提示', options).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        this.$router.push('/login')
      }).catch(() => {})
    },

    // 切换菜单抽屉
    toggleMenu() {
      this.showMenu = !this.showMenu
    },

    // 回到顶部
    scrollToTop() {
      console.log('回到顶部按钮被点击')
      console.log('当前滚动位置:', window.pageYOffset)
      
      // 立即隐藏按钮
      this.showBackToTop = false
      
      // 尝试多种滚动方式
      try {
        // 方法1: 使用 window.scrollTo
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        // 方法2: 直接设置 scrollTop
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
        
        // 方法3: 查找可能的滚动容器
        const appElement = document.getElementById('app')
        if (appElement) {
          appElement.scrollTop = 0
        }
        
        // 方法4: 查找所有可能的滚动容器
        const scrollableElements = document.querySelectorAll('*')
        scrollableElements.forEach(element => {
          const style = window.getComputedStyle(element)
          if (style.overflow === 'auto' || style.overflow === 'scroll' || style.overflowY === 'auto' || style.overflowY === 'scroll') {
            console.log('找到滚动容器:', element)
            element.scrollTop = 0
          }
        })
        
        console.log('滚动命令已执行')
      } catch (error) {
        console.error('滚动失败:', error)
      }
    },

    // 添加滚动监听
    addScrollListener() {
      this.handleScroll = () => {
        // 检查多个可能的滚动位置
        const windowScrollTop = window.pageYOffset || 0
        const documentScrollTop = document.documentElement.scrollTop || 0
        const bodyScrollTop = document.body.scrollTop || 0
        const appScrollTop = document.getElementById('app')?.scrollTop || 0
        
        // 使用最大的滚动值
        const scrollTop = Math.max(windowScrollTop, documentScrollTop, bodyScrollTop, appScrollTop)
        
        this.showBackToTop = scrollTop > 300 && !this.showMenu
        
        console.log('滚动监听:', {
          windowScrollTop,
          documentScrollTop,
          bodyScrollTop,
          appScrollTop,
          maxScrollTop: scrollTop,
          showMenu: this.showMenu,
          showBackToTop: this.showBackToTop
        })
      }
      window.addEventListener('scroll', this.handleScroll, { passive: true })
      
      // 也监听 app 元素的滚动
      const appElement = document.getElementById('app')
      if (appElement) {
        appElement.addEventListener('scroll', this.handleScroll, { passive: true })
      }
    },

    // 移除滚动监听
    removeScrollListener() {
      if (this.handleScroll) {
        window.removeEventListener('scroll', this.handleScroll)
        
        // 也移除 app 元素的监听
        const appElement = document.getElementById('app')
        if (appElement) {
          appElement.removeEventListener('scroll', this.handleScroll)
        }
      }
    }
  }
}
</script>

<style>
/* 设备判断覆盖（统一使用 device.js） */
.device-mobile .mobile-menu-btn { display: flex !important; }
.device-pc .mobile-menu-btn { display: none !important; }

.device-mobile .back-to-top-btn { display: flex !important; }
.device-pc .back-to-top-btn { display: none !important; }

.device-mobile .sidebar,
.device-mobile div.sidebar,
.device-mobile .app-wrapper .sidebar {
  display: none !important;
  width: 0 !important;
  min-width: 0 !important;
  max-width: 0 !important;
  overflow: hidden !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* 设备为移动端时，主内容区域应填充可用宽度（横/竖屏一致） */
.device-mobile .main-container,
.device-mobile .app-wrapper .main-container {
  left: 0 !important;
  margin-left: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: auto;
  min-height: 100vh;
  width: 100%;
  overflow: auto;
  position: relative;
  background-color: #f0f2f5;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  min-height: 100%;
  overflow: auto;
  background-color: #f0f2f5;
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE 10+ */
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none !important; /* Chrome/Safari/Webkit */
}


body {
  position: relative;
  min-height: 100vh;
  height: auto;
}

/* 统一滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 限制Element UI对话框最大宽度 */
.el-dialog {
  max-width: 90% !important;
  margin: 0 auto !important;
}

/* 对于大型对话框，限制最大宽度为1400px */
.el-dialog--large {
  max-width: 1450px !important;
}

/* 对于中型对话框，限制最大宽度为1000px */
.el-dialog--medium {
  max-width: 1050px !important;
}

/* 对于小型对话框，限制最大宽度为800px */
.el-dialog--small {
  max-width: 800px !important;
}

/* 垂直居中显示的对话框 */
.vertical-center-dialog .el-dialog {
  margin-top: 0 !important;
  position: relative;
  top: 30% !important;
  transform: translateY(-50%) !important;
}

/* 固定高度的对话框 */
.fixed-height-dialog .el-dialog {
  height: 80vh !important;
  display: flex;
  flex-direction: column;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  position: relative;
  top: 50% !important;
  transform: translateY(-50%) !important;
  overflow: hidden;
}

.fixed-height-dialog .el-dialog__body {
  flex: 1;
  overflow-y: auto;
  padding-top: 15px;
  padding-bottom: 15px;
}

/* 在超宽屏幕上优化内容区域布局 */
@media (min-width: 1800px) {
  .main-container .content-wrapper {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  }
}

/* PC版中隐藏移动菜单按钮 */
@media (min-width: 769px) {
  .mobile-menu-btn {
    display: none !important;
  }
}

/* 修改移动端菜单按钮样式 */
.mobile-menu-btn {
  display: none !important; /* 默认隐藏 */
  position: fixed !important;
  right: 15px !important;
  bottom: 80px !important; /* 回到原来的位置 */
  width: 40px !important;
  height: 40px !important;
  border-radius: 40px !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #409eff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  transition: all 0.3s ease !important;
  z-index: 2001 !important;
}

/* 回到顶部按钮样式 */
.back-to-top-btn {
  display: none !important; /* 默认隐藏 */
  position: fixed !important;
  right: 15px !important;
  bottom: 25px !important; /* 位于菜单按钮下方40px (80px - 40px) */
  width: 40px !important;
  height: 40px !important;
  border-radius: 40px !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  color: #409EFF !important; /* 使用蓝色 */
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  transition: all 0.3s ease !important;
  z-index: 2001 !important;
}





.mobile-menu-btn i {
  font-size: 20px !important;
}

.mobile-menu-btn:hover, .mobile-menu-btn:focus {
  background-color: rgba(255, 255, 255, 0.8) !important;
  transform: scale(1.05) !important;
}

.mobile-menu-btn:active {
  background-color: rgba(255, 255, 255, 0.9) !important;
  transform: scale(0.95) !important;
}

.back-to-top-btn:hover, .back-to-top-btn:focus {
  background-color: rgba(255, 255, 255, 0.8) !important;
  transform: scale(1.05) !important;
}

.back-to-top-btn:active {
  background-color: rgba(255, 255, 255, 0.9) !important;
  transform: scale(0.95) !important;
}

/* 在小屏幕设备上显示移动菜单按钮 */
@media (max-width: 768px) {
  .mobile-menu-btn {
    display: flex !important;
  }
  
  .back-to-top-btn {
    display: flex !important;
  }
}

/* 暗色模式下移动端按钮样式 */
@media (prefers-color-scheme: dark) {
  .mobile-menu-btn {
    background-color: rgba(30, 30, 30, 0.5) !important;
    color: #67b3fd !important;
  }
  
  .mobile-menu-btn:hover, .mobile-menu-btn:focus {
    background-color: rgba(40, 40, 40, 0.8) !important;
  }
  
  .mobile-menu-btn:active {
    background-color: rgba(50, 50, 50, 0.9) !important;
  }
  
  .back-to-top-btn {
    background-color: rgba(30, 30, 30, 0.5) !important;
    color: #409EFF !important;
  }
  
  .back-to-top-btn:hover, .back-to-top-btn:focus {
    background-color: rgba(40, 40, 40, 0.8) !important;
  }
  
  .back-to-top-btn:active {
    background-color: rgba(50, 50, 50, 0.9) !important;
  }
}

/* PC端 MessageBox 垂直位置调整 - 从 30% 位置开始 */
@media (min-width: 769px) {
  .el-message-box__wrapper:after {
    height: 75% !important;
  }
  
  .el-message-box {
    margin-top: -10vh !important;
  }
}

/* 移动端登出二次确认弹窗优化 */
@media (max-width: 768px) {
  /* 确保弹窗层级高于抽屉 */
  .el-message-box__wrapper {
    z-index: 3002 !important;
  }

  /* 弹窗主体尺寸与圆角、外边距 */
  .mobile-confirm.el-message-box {
    width: 86vw !important;
    max-width: 420px !important;
    border-radius: 10px !important;
    margin: 10vh auto 0 !important;
  }

  .mobile-confirm .el-message-box__header {
    padding: 16px 20px !important;
  }

  .mobile-confirm .el-message-box__title {
    font-size: 16px !important;
  }

  .mobile-confirm .el-message-box__content {
    padding: 12px 20px 0 !important;
    font-size: 14px !important;
    line-height: 1.6 !important;
  }

  .mobile-confirm .el-message-box__btns {
    padding: 16px 20px 20px !important;
  }

  .mobile-confirm .el-button {
    height: 36px !important;
    padding: 0 14px !important;
    font-size: 14px !important;
  }
}

/* 移动端抽屉样式 */
.mobile-drawer {
  background-color: #304156 !important;
  z-index: 2001 !important;
}

.mobile-drawer .drawer-logo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  height: 70px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), transparent);
}

.mobile-drawer .drawer-logo-img {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.mobile-drawer .drawer-title {
  font-size: 16px;
  font-weight: bold;
  color: #eeba4c;
  margin-left: 10px;
}

.mobile-drawer .close-btn {
  background-color: transparent;
  border: none;
  color: #bfcbd9;
}

.mobile-drawer .close-btn:hover {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
}

.mobile-drawer .mobile-menu {
  border-right: none !important;
  width: 100%;
  flex: 1 1 auto;
  overflow-y: auto;
}

/* 修复抽屉遮罩层问题 */
.el-drawer__container {
  z-index: 2001 !important;
}

.v-modal {
  z-index: 2000 !important;
  opacity: 0.3 !important;
}

/* 修复 $prompt 弹窗被遮罩层遮挡 */
.el-message-box__wrapper {
  z-index: 2010 !important;
}

/* 确保移动抽屉背景色统一 - 仅应用于移动菜单 */
.mobile-drawer.el-drawer {
  background-color: #304156 !important;
}

.mobile-drawer.el-drawer .el-drawer__header {
  background-color: #304156 !important;
  margin: 0 !important;
  padding: 0 !important;
  color: #eeba4c !important;
}

.mobile-drawer.el-drawer .el-drawer__body {
  background-color: #304156 !important;
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}

/* 移动端全局样式 */
@media (max-width: 768px) {
  /* 隐藏侧边栏 */
  .sidebar,
  div.sidebar,
  .app-wrapper .sidebar {
    display: none !important;
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    overflow: hidden !important;
    visibility: hidden !important;
    opacity: 0 !important;
  }
  

  
  /* 调整主内容区域 */
  .main-container,
  .app-wrapper .main-container {
    left: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  
  /* 修复移动端菜单样式 */
  .mobile-drawer .el-menu .el-submenu.is-opened .el-menu--inline {
    margin: 0 !important;
    padding: 0 !important;
  }
  
  /* 强制移除菜单间距 */
  .el-submenu__title + .el-menu,
  .el-submenu.is-opened .el-menu--inline {
    margin: 0 !important;
    padding: 0 !important;
  }
  
  /* 修复菜单项高度 */
  .mobile-drawer .el-menu-item,
  .mobile-drawer .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
    margin: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  
  /* 修复子菜单样式 */
  .mobile-drawer .el-menu--inline .el-menu-item {
    height: 40px !important;
    line-height: 40px !important;
    margin: 0 !important;
  }
  
  /* 彻底解决二级菜单展开后的样式问题 */
  .el-submenu.is-opened .el-menu--inline {
    background-color: #1f2d3d !important;
  }
  
  /* 移除所有可能的分隔线和间距 */
  .el-menu,
  .el-menu--inline,
  .el-menu-item,
  .el-submenu__title {
    border: none !important;
    border-top: none !important;
    border-bottom: none !important;
  }
  
  /* 移除菜单项间的所有间距 */
  .el-menu-item + .el-menu-item,
  .el-submenu + .el-menu-item,
  .el-menu-item + .el-submenu,
  .el-submenu + .el-submenu {
    margin-top: 0 !important;
    border-top: none !important;
  }
  
  /* 隐藏子菜单中的所有分隔元素 */
  .el-menu--inline::before,
  .el-menu--inline::after,
  .el-menu-item::before,
  .el-menu-item::after,
  .el-submenu__title::before,
  .el-submenu__title::after {
    display: none !important;
    content: none !important;
  }
  
  /* 修复数据菜单特殊样式 */
  .el-submenu[data-index="analysis"] .el-menu--inline,
  .el-submenu[data-index="article"] .el-menu--inline,
  .el-submenu[data-index="manage"] .el-menu--inline {
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
  }
}

/* 全局覆盖Element UI菜单样式,消除间距问题 */
.mobile-drawer .el-menu .el-submenu.is-opened .el-menu--inline {
  margin: 0 !important;
  padding: 0 !important;
  background-color: #1f2d3d !important;
}

.mobile-drawer .el-menu .el-submenu.is-opened .el-submenu__title {
  margin-bottom: 0 !important;
  border-bottom: none !important;
}

.mobile-drawer .el-menu .el-menu-item, 
.mobile-drawer .el-menu .el-submenu__title {
  height: 50px !important;
  line-height: 50px !important;
  margin: 0 !important;
  padding: 0 20px !important;
  border: none !important;
}

.mobile-drawer .el-menu .el-submenu .el-menu-item {
  height: 40px !important;
  line-height: 40px !important;
  padding-left: 40px !important;
}

.mobile-drawer .el-menu .el-menu--inline {
  border-top: none !important;
}

/* 强制覆盖Element UI菜单过渡效果 */
.mobile-drawer .el-menu--collapse-transition {
  transition: none !important;
}

/* 强制修复菜单间距 */
.mobile-drawer .el-submenu__title,
.mobile-drawer .el-menu-item {
  margin: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* 强制修复二级菜单展开后的样式 */
.mobile-drawer .el-submenu.is-opened > .el-submenu__title + .el-menu--inline {
  margin: 0 !important;
  padding: 0 !important;
}

/* 修复二级菜单展开后的样式问题 */
.mobile-drawer .no-submenu-line.el-submenu.is-opened > .el-submenu__title {
  border-bottom-color: transparent !important;
}

.mobile-drawer .no-submenu-line.el-submenu.is-opened > .el-menu {
  border-top: none !important;
}

.mobile-drawer .no-submenu-line.el-submenu.is-opened .el-menu-item {
  border-bottom: none !important;
}

.mobile-drawer .no-submenu-line.el-submenu.is-opened .el-menu-item-group__title {
  display: none !important;
  height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
}

/* 修复二级菜单箭头和内容错位问题 */
.mobile-drawer .el-submenu__title {
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  height: 50px !important;
  line-height: 50px !important;
  padding-right: 30px !important;
}

/* 修复箭头位置 - 垂直居中显示 */
.mobile-drawer .el-submenu__icon-arrow {
  position: absolute !important;
  right: 10px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  top: 65% !important;
  transform: translateY(-50%) !important;
  z-index: 1 !important;
  line-height: 50px !important;
  vertical-align: baseline !important;
  display: inline-block !important;
  height: 50px !important;
  font-size: 12px !important;
}

/* 修复菜单项图标和文字布局 */
.mobile-drawer .el-menu-item i,
.mobile-drawer .el-submenu__title i {
  margin-right: 10px !important;
  font-size: 18px !important;
  width: auto !important;
  text-align: center !important;
}

/* 修复菜单项文字样式 */
.mobile-drawer .el-menu-item span,
.mobile-drawer .el-submenu__title span {
  flex: 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* 修复二级菜单项高度 */
.mobile-drawer .el-menu--inline .el-menu-item {
  height: 40px !important;
  line-height: 40px !important;
}

/* 抽屉底部用户信息与登出按钮区域 */
.mobile-drawer .drawer-bottom-container {
  padding: 12px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
}

.mobile-drawer .drawer-bottom-container .bottom-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 20px;
  align-items: center;
}

.mobile-drawer .drawer-bottom-container .avatar,
.mobile-drawer .drawer-bottom-container .logout-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #bfcbd9;
  transition: all 0.3s;
  border-radius: 4px;
}

.mobile-drawer .drawer-bottom-container .avatar {
  background-color: #1890ff;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
}

.mobile-drawer .drawer-bottom-container .avatar:hover,
.mobile-drawer .drawer-bottom-container .logout-btn:hover {
  color: #409EFF;
  background-color: rgba(255, 255, 255, 0.1);
}

.mobile-drawer .drawer-bottom-container .logout-btn i {
  font-size: 18px;
}

/* 大纲选择下拉菜单样式已在全局样式文件中定义 */

/* 全局隐藏滚动条 */
html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
#app::-webkit-scrollbar-track {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
#app::-webkit-scrollbar-thumb {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html::-webkit-scrollbar-corner,
body::-webkit-scrollbar-corner,
#app::-webkit-scrollbar-corner {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html,
body,
#app {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}

/* 全局强制隐藏所有滚动条 */
*::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
}

*::-webkit-scrollbar-track {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

*::-webkit-scrollbar-thumb {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

*::-webkit-scrollbar-corner {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

* {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
</style> 